<template>
  <project-details-full :projectId="projectId" :showHistory="true" />
</template>

<script>
import ProjectDetailsFull from '../components/ProjectDetailsFull.vue';

export default {
  components: {
    'project-details-full': ProjectDetailsFull,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
};
</script>
